export default __webpack_public_path__ + "tenant-background.jpg";